import { useEffect } from "react";
import React, { useState } from "react";
import _ from "lodash";
import { TableControl } from "../../../../../components/controls";
import ButtonControl from "../../../../../components/controls/ButtonControl";

const GuardrailTable = ({
  filteredItems,
  onEdit,
  onDelete,
  setSystemPromptDialogOpen,
  navigate,
}) => {
  const [rows, setRows] = useState([]);
  const [columns] = useState([
    {
      header: "Title",
      dataProp: "promptTitle",
      width: "26%",
      canSort: false,
    },
    {
      header: "Type",
      dataProp: "promptType",
      width: "21%",
      canSort: true,
    },
    {
      header: "Content",
      dataProp: "promptContent",
      width: "25%",
      canSort: false,
    },
    {
      header: "Active?",
      dataProp: "isActive",
      width: "5%",
      canSort: true,
      datatype: "bool",
      isBool: true,
    },
    {
      header: "Order",
      dataProp: "order",
      width: "5%",
      canSort: true,
      isOrder: false,
    },
  ]);

  useEffect(() => {
    if (filteredItems) {
      setRows([...filteredItems]);
    }
  }, [filteredItems]);

  return (
    <div className="vl-content-wrapper limit-table-sizing">
      <TableControl
        columns={columns}
        permission="Tag"
        data={rows}
        useIntegratedPaging={["10", "25", "50", "100"]}
        onEdit={(row) => onEdit(row.id)}
        onDelete={onDelete}
      />
      <div className="screen-footer">
        {
          <>
            <ButtonControl
              type={"create"}
              onClick={() => {
                navigate("/admin/EchoAI/guardrails/addnew");
              }}
            >
              New Prompt
            </ButtonControl>
            &nbsp;
          </>
        }
        {
          <>
            <ButtonControl
              type={"cancel"}
              onClick={() => {
                setSystemPromptDialogOpen(true);
              }}
            >
              View System Prompt
            </ButtonControl>
            &nbsp;
          </>
        }
      </div>
    </div>
  );
};

export default GuardrailTable;
